import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { CloseOutlined } from '@mui/icons-material';
import ToastHandler from 'components/Toast-Handler/toast-handler';

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  paddingRight: theme.spacing(3),
}));

const DialogTitle = ({ children, onClose }) => (
  <StyledDialogTitle>
    <Typography variant='subtitle1'>{children}</Typography>
    <Box display='flex' alignItems='center' gap={1}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        size="large">
        <CloseOutlined />
      </IconButton>
    </Box>
  </StyledDialogTitle>
);

const NotificationDialog = ({
  open,
  title,
  isProcessing,
  toast,
  children,
  width,
  handlePrimary,
  handleClose }) => {
  return (
    <Dialog
      maxWidth={width ? width : 'sm'}
      fullWidth
      open={open}
      onClose={handleClose}
    >
      <DialogTitle onClose={handleClose}>
        {title}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {isProcessing && <CircularProgress style={{margin: '0px 50%'}} />}
        {toast && toast.type ? <ToastHandler toast={toast} type={toast.type} /> : ''}  { /*This needs to be included with all forms */}
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePrimary} color='primary'>OK</Button>
      </DialogActions>
    </Dialog>
  );
};
export default NotificationDialog;